import helpers from '@/router/helpers';
import UserRoles from '@/constants/user/roles';

export default {
    path: '/inventory/join-physical',
    meta: {
        title: 'Join Physical',
        documentTitle: 'Join Physical',
        requiresAuth: true,
        mdiIcon: '',
        shouldPersistBetweenLogins: true,
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.INVENTORY_OPERATOR,
            UserRoles.INVENTORY_ADMINISTRATOR,
        ],
    },
    component: helpers.getRouterView(),
    children: [
        {
            path: '',
            name: 'InventoryJoinPhysical',
            meta: {
                title: 'Join Physical',
                documentTitle: 'Inventory Join Physical',
                allowedRoles: [
                    UserRoles.SUPER_ADMIN,
                    UserRoles.INVENTORY_OPERATOR,
                    UserRoles.INVENTORY_ADMINISTRATOR,
                ],
            },
            component: () => import( /* webpackChunkName: "InventoryJoinPhysical" */ '@/views/inventory/JoinPhysical' ),
        },
    ],
};
